import React, { useRef, useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";
import { patientQueueCountData } from "../../reduxStore/actions/commonAction";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CircularProgress } from "@material-ui/core";
import { patientsInQueue } from "../../apiRoutes";
import Label from "../../components/label";
import ICPhoneDisplay from "../../components/phoneDisplay";

import {
  getFormattedDate,
  getFormattedTimeV2
} from "../../utils/dateTimeHelper";

function createData(
  _id,
  patientID,
  patientId,
  patientEmail,
  phoneNumber,
  patientName,
  createdDate,
  createdTime,
  appointmentId,
  isBulkBilled
) {
  return {
    _id,
    patientID,
    patientId,
    patientEmail,
    phoneNumber,
    patientName,
    createdDate,
    createdTime,
    appointmentId,
    isBulkBilled
  };
}

const StickyHeadTable = (props) => {
  const observer = useRef(); // to check it is the last element or not - if it is last element then call an API
  const [pageNo, setPageNumber] = useState(1); // just set page number if needed in future.
  const [nextPage, setNextPage] = useState(false); // set next page if there is more data
  const [loading, setLoading] = useState(true); // loading variable used to reduce multiple API calls
  const [progressBar, setProgressBar] = useState(false); // progress bar hide and show
  const [limit, setLimit] = useState(10); // limit is fixed but if we need to change in future then change it here
  const [skip, setSkip] = useState(0); // set Skip page
  const [noMoreData, setNoMoreData] = useState(false); // no data found block hide-show

  // Column Names - if you want to add an column then add id and label here - also take care of createData function (need to pass data)
  const columns = [
    {
      id: "patientUIN",
      label: "Patient UIN",
      style: { width: "115px" }
    },
    {
      id: "patientDetails",
      label: "Patient Details",
      style: { width: "230px" }
    },
    {
      id: "date",
      label: "Date",
      style: { width: "115px" }
    },
    {
      id: "billing",
      label: "Billing",
      style: { width: "120px" }
    }
  ];

  // Data to be appended
  const [rows, setRows] = useState([]); // setting rows

  /*
   * Check last element is visible or not on scroll
   */
  const lastElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(data => {
      if (data) {
        if (data[0].isIntersecting && nextPage && loading) {
          setLoading(false);
          if (loading) {
            let skipCalculate = limit * pageNo,
              currentPageNo = pageNo + 1;
            setPageNumber(currentPageNo);
            setSkip(skipCalculate);
            getQueueList(
              limit,
              skipCalculate,
              props.statusFilter,
              currentPageNo
            );
          }
          setTimeout(() => {
            setLoading(true);
          }, 2000);
        }
      }
    });
    if (node) observer.current.observe(node);
  });

  /*
   * Main function to call an API
   * Pass parameters compulusry (limit, skipPage, filterStatus) to calculate pagination and check filter
   */

  const getQueueList = useCallback((limitPage, skipPage, currentPage) => {
    let updatedParam = {
      limit: limitPage,
      skip: skipPage
    };
    let apiCallParam = {
      reqType: "GET",
      reqURL: patientsInQueue,
      dataObj: {},
      params: updatedParam,
      headers: {},
      successCallback: res => {
        // calculate is there any next page or not ?
        let currentRowCount = res.data.data.count - currentPage * limitPage;
        if (currentRowCount > 0) {
          setNextPage(true);
        } else {
          setNextPage(false);
          setNoMoreData(true);
          setProgressBar(false);
        }

        // set the data
        let queueData = [];
        res.data.data.appointments.map((value, index) => {
          let d = {};

          d._id = value.appointmentId;
          if (value.patientId != null) {
            d.patientID = value.patientId._id;
            d.patientId = value.patientId.patientId;
            d.patientEmail = value.patientId.email;
            d.phoneNumber = value.patientId.phoneNumber;
            if (
              value.patientId.middleName === "" ||
              value.patientId.middleName === null ||
              value.patientId.middleName === undefined ||
              value.patientId.middleName === "undefined"
            ) {
              d.patientMiddle = " ";
            } else {
              d.patientMiddle = value.patientId.middleName;
            }
            d.patientName =
              value.patientId.firstName +
              " " +
              d.patientMiddle +
              " " +
              value.patientId.lastName;
          } else {
            d.patientID = "";
            d.patientId = "";
            d.patientMiddle = "";
            d.patientName = "";
            d.patientEmail = "";
            d.phoneNumber = "";
          }

          d.createdDate = getFormattedDate(value.createdAt);
          d.createdTime = getFormattedTimeV2(value.createdAt);
          d.appointmentId = value.appointmentId;
          d.isBulkBilled = value.isBulkBilled ? true : false;

          console.log("---------- d ", d);

          queueData.push(
            // createData used for Material UI table to set the data (if you include anything, don't forget to include in createData function at the top or bottom of the file)
            createData(
              d.appointmentId,
              d.patientID,
              d.patientId,
              d.patientEmail,
              d.phoneNumber,
              d.patientName,
              d.createdDate,
              d.createdTime,
              d.appointmentId,
              d.isBulkBilled
            )
          );
        });
        if (skipPage === 0) {
          setRows(queueData);
        } else {
          setRows(prev => prev.concat(queueData));
        }

        props.patientQueueCountData(res.data.data.count);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        setNextPage(false);
        setNoMoreData(true);
        setProgressBar(false);
      },
      showPopUp: false
    };
    props.makeAPICall(apiCallParam);
  });

  /*
   * Watch on filter
   */
  useEffect(() => {
    resetPagination();
    setRows([]);
    getQueueList(limit, 0, 1);
  }, []);

  // refresh the list upon button click
  useEffect(() => {
    if (props.refreshList === true) {
      resetPagination();
      setRows([]);
      getQueueList(limit, 0, 1);
    }
  }, [props.refreshList]);

  /*
   * Reset pagination
   */
  const resetPagination = () => {
    setPageNumber(1);
    setNextPage(false);
    setLoading(true);
    setProgressBar(true);
    setSkip(0);
    setNoMoreData(false);
  };

  return (
    <Paper className="w-100 ticket-list-tbl-div">
      <TableContainer className="table-max-height primary-table-color">
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            {/* Loop on Column name  */}
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id} style={column.style}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Loop over the data (createData function) */}
            {rows.map((row, index) => {
              /*
               * If it is last element then take the referent to call an API Else print another block
               */
              if (rows.length === index + 1) {
                let tem =
                  (noMoreData && !rows.length) ||
                  (noMoreData && rows.length === limit) ||
                  (noMoreData && pageNo > 1)
                    ? ""
                    : "border-bottom-0";

                return (
                  <TableRow
                    className={row.isBulkBilled ? "cursor-pointer pale-green-bg" : "cursor-pointer"}
                    ref={lastElementRef}
                    hover
                    key={row._id}
                    onClick={e => {
                      props.acceptAppointment(row);
                    }}
                  >
                    <TableCell className={tem}>{row.patientId}</TableCell>
                    <TableCell className={tem}>
                      <p className="mb-0">
                        <b>{row.patientName}</b>
                      </p>
                      {row.patientEmail}
                      <p className="mb-0">
                        <ICPhoneDisplay value={row.phoneNumber} />
                      </p>
                    </TableCell>
                    <TableCell className={tem}>
                      <p className="mb-0">{row.createdDate}</p>
                      <p className="mb-0">{row.createdTime}</p>
                    </TableCell>
                    <TableCell className={tem}>
                      {row.isBulkBilled ? "Medicare" : "Private"}
                    </TableCell>
                  </TableRow>
                );
              } else {
                return (
                  <TableRow
                    onClick={e => {
                      props.acceptAppointment(row);
                    }}
                    className={row.isBulkBilled ? "cursor-pointer pale-green-bg" : "cursor-pointer"}
                    hover
                    key={row._id}
                  >
                    <TableCell>{row.patientId}</TableCell>
                    <TableCell>
                      <div className="d-flex flex-column position-relative">
                        <p className="mb-0">
                          <b>{row.patientName}</b>
                        </p>
                        {row.patientEmail}
                        <p className="mb-0">
                          <ICPhoneDisplay value={row.phoneNumber} />
                        </p>
                      </div>
                    </TableCell>
                    <TableCell>
                      <p className="mb-0">{row.createdDate}</p>
                      <p className="mb-0">{row.createdTime}</p>
                    </TableCell>
                    <TableCell>
                      {row.isBulkBilled ? "Medicare" : "Private"}
                    </TableCell>
                  </TableRow>
                );
              }
            })}

            {/*
             * Progress bar on loading APIs
             */}

            <TableRow className={progressBar ? "" : "d-none"}>
              <TableCell colSpan={7} className="text-center">
                <CircularProgress disableShrink className="primary-loader" />
              </TableCell>
            </TableRow>

            {/*
             * No data fount if there are no data array in API or clear btn clicked
             */}

            <TableRow
              className={
                (noMoreData && !rows.length) ||
                (noMoreData && rows.length === limit) ||
                (noMoreData && pageNo > 1)
                  ? ""
                  : "d-none"
              }
            >
              <TableCell
                colSpan={6}
                className="text-center progress-bar-center border-bottom-0"
              >
                <Label title="No data found" />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

// export default DoctorSignUp;

const mapStateToProps = props => ({
  commonReducers: props.commonReducers
});

const mapDispatchToProps = dispatch => ({
  patientQueueCountData: data => dispatch(patientQueueCountData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StickyHeadTable);
